import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "toggle", "button"];

  connect() {
    this.update();
  }

  toggleAll() {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = this.toggleTarget.checked;
    });
    this.update();
  }

  update() {
    const checkedCount = this.checkboxTargets.filter(
      (checkbox) => checkbox.checked,
    ).length;
    const allChecked = checkedCount === this.checkboxTargets.length;

    this.toggleTarget.checked = checkedCount > 0 && allChecked;
    this.toggleTarget.indeterminate = checkedCount > 0 && !allChecked;
    this.buttonTarget.disabled = checkedCount === 0;
  }
}
